import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

/* Helpers */
import 'moment/locale/tr';

/* Services */
import AuthService from "../../../services/auth.service";

/* Ant Design */
import { Button, Typography, Form, Input, Divider } from 'antd';

let clearTimer;

const DoctorProfilePassword = (props) => {
    const [loadingForm, setLoadingForm] = useState(false);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [equalPassword, setEqualPassword] = useState(true);

    useEffect(() => {
        return () => {
            clearTimeout(clearTimer);
        }
    }, []);

    const onFormChange = (changedValues, values) => {
        values.newPassword === values.verifyNewPassword ?
            setEqualPassword(true)
            :
            setEqualPassword(false);

        (
            (values.hasOwnProperty("oldPassword") && typeof values["oldPassword"] === 'string' && values["oldPassword"].length) &&
            (values.hasOwnProperty("newPassword") && typeof values["newPassword"] === 'string' && values["newPassword"].length) &&
            (values.hasOwnProperty("verifyNewPassword") && typeof values["verifyNewPassword"] === 'string' && values["verifyNewPassword"].length)
        )
            ?
            setButtonDisable(false)
            :
            setButtonDisable(true);
        /*TODO --> Orjinal Data değiştiğinde eğer sayfadan çıkılmaya çalışılıyor ise modal ile 
                    "Kaydetmeden Çıkmak İstediğinize Emin Misiniz?" diye sorarak çıkış yapılmalıdır.
        */
    }

    const onFinish = (values) => {
        setLoadingForm(true);
        if (values) {
            if (values.newPassword === values.verifyNewPassword) {
                delete values.verifyNewPassword;

                AuthService.doctorChangePassword(values)
                    .then(
                        (response) => {
                            toast.success(response.data.message, { autoClose: 3000 });
                            setButtonDisable(true);
                            setLoadingForm(false);
                            clearTimer = setTimeout(() => {
                                props.history.push("/doctor/profile");
                            }, 3000);
                        },
                        error => {
                            const resMessage =
                                (error.response &&
                                    error.response.data &&
                                    error.response.data.message) ||
                                error.message ||
                                error.toString();

                            toast.error(resMessage);
                            setLoadingForm(false);
                        }
                    )
            } else {
                setButtonDisable(true);
                setLoadingForm(false);
            }
        }
    }

    return (
        <div>
            <div style={{ textAlign: 'center', marginBottom: '5vh' }}>
                <Typography.Title level={4}>
                    Şifre Değiştir
                </Typography.Title>
            </div>
            <Form
                name="doctorPassword"
                labelCol={{
                    xs: { offset: 0 },
                    sm: { offset: 0, span: 6 },
                    md: { offset: 1, span: 6 },
                    lg: { offset: 4, span: 4 },
                }}
                wrapperCol={{
                    xs: { offset: 0 },
                    sm: { offset: 0, span: 12 },
                    md: { offset: 0, span: 10 },
                    lg: { offset: 0, span: 8 },
                }}
                onFinish={onFinish}
                onValuesChange={(changedValues, values) => onFormChange(changedValues, values)}
                autoComplete="off"
            >
                {/* Old Password */}
                <Form.Item
                    label="Şifre"
                    name="oldPassword"
                    rules={[
                        {
                            required: true,
                            message: 'Lütfen Şuanki Şifrenizi Giriniz!',
                            min: 4,
                            max: 16,
                        },
                    ]}
                >
                    <Input.Password
                        placeholder="Lütfen Şuanki Şifrenizi Giriniz!"
                        maxLength={16}
                    />
                </Form.Item>
                <Divider />

                {/* New Password */}
                <Form.Item
                    label="Yeni Şifre"
                    name="newPassword"
                    rules={[
                        {
                            required: true,
                            message: 'Lütfen Yeni Şifrenizi Giriniz!',
                            min: 4,
                            max: 16,
                        },
                    ]}
                >
                    <Input.Password
                        placeholder="Lütfen Yeni Şifrenizi Giriniz!"
                        maxLength={16}
                    />
                </Form.Item>

                {/* New Password Verify */}
                <Form.Item
                    label="Yeni Şifre Doğrula"
                    name="verifyNewPassword"
                    validateStatus={equalPassword === true ? "success" : "error"}
                    rules={[
                        {
                            required: true,
                            message: 'Lütfen Yeni Şifrenizi Doğrulamak için Tekrar Giriniz!',
                            min: 4,
                            max: 16,
                        },
                    ]}
                >
                    <Input.Password
                        placeholder="Lütfen Yeni Şifrenizi Doğrulamak için Tekrar Giriniz!"
                        maxLength={16}
                    />
                </Form.Item>

                {/* Submit */}
                <Form.Item
                    wrapperCol={{
                        xs: { offset: 0 },
                        sm: { offset: 6, span: 12 },
                        md: { offset: 7, span: 10 },
                        lg: { offset: 8, span: 8 },
                    }}
                >
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        loading={loadingForm}
                        disabled={buttonDisable}
                    >
                        Kaydet
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}


const mapState = (state) => ({
});

const mapDispatch = (dispatch) => ({
});

export default connect(mapState, mapDispatch)(DoctorProfilePassword);